module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jnKFM"))).then(() => parcelRequire('d0iPb'));